"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPresentationOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M21 4v12c0 1.332-.667 1.999-2 2h-4.366l.72 2.689c.173.644-.063 1.052-.707 1.224-.644.173-1.052-.063-1.225-.707L12.563 18h-1.126l-.86 3.206c-.172.644-.58.88-1.224.707-.644-.172-.88-.58-.707-1.224L9.366 18H5c-1.333 0-2-.667-2-2V4c-.667 0-1-.333-1-1s.333-1 1-1h18c.667 0 1 .333 1 1s-.333 1-1 1zm-2 0H5v12h14V4zm-8 4.167c0-.775.333-1.164 1-1.167.667-.003 1 .386 1 1.167v4.666c0 .778-.333 1.167-1 1.167s-1-.389-1-1.167V8.167zm4-1.042C15 6.375 15.333 6 16 6s1 .375 1 1.125v5.75c0 .752-.333 1.127-1 1.125-.667-.002-1-.377-1-1.125v-5.75zM7 10.25C7 9.417 7.333 9 8 9s1 .417 1 1.25v2.5C9 13.583 8.667 14 8 14s-1-.417-1-1.25v-2.5z' }))); };
exports.default = SvgPresentationOutline;
//# sourceMappingURL=PresentationOutline.js.map